export default "__VITE_ASSET__ifv4CXaK__"